import { useMemo } from 'react';

import { useListConsumerFamilyCauses } from '@givebacks/api/backer';
import { UseFormReturnType } from 'ui/Form';

import { SearchableMultiSelect } from '../../../../../molecules/inputs/SearchableInputs/SearchableMultiSelect';
import { useDirectorySettingsModalProvider } from '../../DirectorySettingsModalProvider';
import { ChildProfileForm } from './types';
import { useSearchFamilyCausesFn } from './useSearchFamilyCauses';

const ChildOrganizationSearchableMultiselect = ({
  form,
}: {
  form: UseFormReturnType<ChildProfileForm>;
}) => {
  const { meta } = useDirectorySettingsModalProvider({});
  const { data: causes } = useListConsumerFamilyCauses({ familyId: meta.familyId });

  const useSearchFamilyCauses = useSearchFamilyCausesFn(meta.familyId);

  const causesData = useMemo(() => {
    return causes?.map((cause) => ({
      value: cause.uuid,
      label: cause.name || cause.uuid,
    }));
  }, [causes]);

  return (
    <SearchableMultiSelect
      label="Organizations"
      initialData={causesData}
      useFetchSource={useSearchFamilyCauses}
      {...form.getInputProps('organizationIds')}
    />
  );
};

export { ChildOrganizationSearchableMultiselect };
